import { Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GrundstueckFormService } from '../../grundstueck-form-service';
import { ActivatedRoute, Router } from '@angular/router';
import { GbgrundstueckService, GrundstueckSearchRequestEgridMeta } from '../../../core/gb-api';
import { FormsModule, NgForm } from '@angular/forms';
import { TimepointService } from '../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../shared/enum/searchMode';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { AutofocusDirective } from '../../../shared/directives/autofocus.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { HistoryOptionsComponent } from '../../../shared/widgets/history-options/history-options.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-suche-egrid',
  templateUrl: './grundstueck-suche-egrid.component.html',
  styleUrls: ['./grundstueck-suche-egrid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    AutofocusDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    HistoryOptionsComponent,
    TranslatePipe
  ]
})
export class GrundstueckSucheEgridComponent extends AbstractSearchComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  egrid: GrundstueckSearchRequestEgridMeta;
  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private grundstueckService: GbgrundstueckService,
    private formService: GrundstueckFormService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit(): void {
    if (this.stateService.lastRequest) {
      this.egrid = this.stateService.lastRequest;
    } else {
      this.egrid = <GrundstueckSearchRequestEgridMeta>{};
    }

    this.subscription = this.grundstueckService
      .searchGrundstueckEgridTemplate()
      .subscribe((template) => (this.egrid = this.copyLastRequest(template, SearchMode.searchFachId)));
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.egrid;
    this.timepointService.resetTimepoint();
    this.formService.submit(this.form, SearchMode.searchFachId, this.egrid, this.router, this.route, true);
  }

  onReset(autofocusInput) {
    this.form.reset();
    this.subscription = this.grundstueckService.searchGrundstueckEgridTemplate().subscribe((template) => {
      this.egrid = template;
    });
    autofocusInput.focus();
  }

  trim(inputValue: string) {
    if (inputValue && this.egrid && this.egrid.egrid) {
      this.egrid.egrid.value = inputValue.trim();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // required for egrid-trim
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
